import { useContext } from 'react';
import {
  ReportExportContext,
  ReportExportContextValue
} from 'components/Reporting/ReportExportContext';

export const useReportExport = (): ReportExportContextValue => {
  const context = useContext(ReportExportContext);

  if (!context) {
    throw new Error(
      'useReportExport must be used within a ReportExportProvider'
    );
  }

  return context;
};
